import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMarketingPageView } from "@/lib/analytics/marketingSiteTracker";
import { onConsentChange } from "@/lib/cookieConsent";

// SK-only public routes (not /en /de). /objednavka and /podpis-zmluvy are transactional,
// already noindex — excluded from pageview stats on purpose, not an oversight.
const MARKETING_PATHS = new Set(["/", "/realitky", "/blog", "/riesenia", "/realizacie", "/kontakt", "/ochrana-sukromia", "/obchodne-podmienky"]);
const MARKETING_PATH_PREFIXES = ["/blog/", "/riesenia/", "/realizacie/"];

function isTrackedPath(pathname: string): boolean {
  return MARKETING_PATHS.has(pathname) || MARKETING_PATH_PREFIXES.some((p) => pathname.startsWith(p));
}

/**
 * Meranie návštevnosti webnaprenajom.sk — nie v CRM ani auth.
 * recordWebsiteAnalytics() gates everything behind analytics-cookie consent; this component
 * additionally re-fires the current page's pageview the moment consent is granted mid-visit
 * (mirrors PixelConsentGate's reactive re-arm for marketing consent in App.tsx), so a visitor
 * who accepts the cookie banner after landing still gets counted without needing a reload.
 */
export function MarketingAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isTrackedPath(pathname)) return;
    trackMarketingPageView(pathname);
  }, [pathname]);

  useEffect(
    () =>
      onConsentChange(() => {
        if (isTrackedPath(window.location.pathname)) {
          trackMarketingPageView(window.location.pathname);
        }
      }),
    [],
  );

  return null;
}
